module.exports = __webpack_public_path__ + "img/Summary.38b1fa99.svg";